import React, { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import InputConfig from '../../../../../Components/InputConfig';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import { validatePlatformObj } from '../../../../../utilities/tgmrDocChecks';
import { toast } from 'react-toastify';
import constants from '../../NetworkData/constants.json';

//mui imports====
import { Grid } from '@mui/material';
//===============

const {
	platforms: { DESKTOP, MOBILE, TABLET },
	tgmrConstants: { PLATFORM_DESKTOP, PLATFORM_MOBILE, AP_BANNERSECTIONID }
} = constants;

const PlatformBannerConfig = ({ keyData, platform, desktopAdObj = {}, mobileAdObj = {} }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	const bannerObj = platform === DESKTOP ? desktopAdObj : mobileAdObj;
	const bannerSectionIdKeyData = keyData + '.' + AP_BANNERSECTIONID;
	/**
	 * @name onDesktopSectionIdEnabled
	 * @description The function is used to enable the desktop section Id for overlay ads, it has several conditions which are to be fulfilled to enable the overlay ad configuration
	 * 1. check desktop Ap Tag object and desktop section Id
	 * @param {Object} enabled - It is an enabled flag whether to enable desktop section in overlay ads or not
	 */
	const onDesktopSectionIdEnabled = (enabled) => {
		try {
			//1. Validating Desktop Ad object and desktop section Id
			validatePlatformObj(
				desktopAdObj,
				platform,
				rawConfig[bannerSectionIdKeyData],
				PLATFORM_DESKTOP,
				AP_BANNERSECTIONID
			);

			updateRawConfig((rawObj) => {
				let deepClonedObj = structuredClone(rawObj);
				return { ...deepClonedObj, [keyData + '.enabled']: enabled };
			});
		} catch (err) {
			toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
			console.error(err);
		}
	};

	/**
	 * @name onMobileSectionIdEnabled
	 * @description The function is used to enable the mobile section Id for overlay ads, it has several conditions which are to be fulfilled to enable the overlay ad configuration
	 * 1. check mobile Ap Tag object and mobile section Id
	 * @param {Object} enabled - It is an enabled flag whether to enable mobile section in overlay ads or not
	 */
	const onMobileSectionIdEnabled = (enabled) => {
		try {
			//1. Validating Mobile Ad object and mobile section Id
			validatePlatformObj(
				mobileAdObj,
				platform,
				rawConfig[bannerSectionIdKeyData],
				PLATFORM_MOBILE,
				AP_BANNERSECTIONID
			);

			updateRawConfig((rawObj) => {
				let deepClonedObj = structuredClone(rawObj);
				return { ...deepClonedObj, [keyData + '.enabled']: enabled };
			});
		} catch (err) {
			toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
			console.error(err);
		}
	};

	return (
		<Grid
			container
			spacing={2}
			style={{ width: '90%', marginLeft: '0.3rem', marginBottom: '1rem', marginTop: '2rem' }}
		>
			{platform === DESKTOP && (
				<>
					<Grid item xs={2}>
						<CheckBoxInput
							keyData={keyData + '.enabled'}
							label="enabled"
							disabled={false}
							defaultChecked={false}
							isObjectEditor={false}
							directValue={rawConfig[keyData + '.enabled']}
							updateDirectValue={(enabled) => {
								onDesktopSectionIdEnabled(enabled);
							}}
							containerStyles={{ marginTop: '4rem', width: 'fit-content' }}
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							label="Desktop BannerId"
							keyData={bannerSectionIdKeyData}
							editable={false}
							isObjectEditor={false}
							directValue={rawConfig[bannerSectionIdKeyData]}
							updateDirectValue={() => {}}
						/>
					</Grid>
				</>
			)}
			{(platform === MOBILE || platform === TABLET) && (
				<>
					<Grid item xs={2}>
						<CheckBoxInput
							keyData={keyData + '.enabled'}
							label="enabled"
							disabled={false}
							defaultChecked={false}
							isObjectEditor={false}
							directValue={rawConfig[keyData + '.enabled']}
							updateDirectValue={(enabled) => {
								onMobileSectionIdEnabled(enabled);
							}}
							containerStyles={{ marginTop: '4rem', width: 'fit-content' }}
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							label="Mobile BannerId"
							keyData={bannerSectionIdKeyData}
							editable={false}
							isObjectEditor={false}
							directValue={rawConfig[bannerSectionIdKeyData]}
							updateDirectValue={() => {}}
						/>
					</Grid>
				</>
			)}
			<Grid item xs={3}>
				<InputConfig
					label="Banner Width"
					keyData={bannerObj?.width}
					editable={false}
					isObjectEditor={false}
					directValue={bannerObj?.width}
					updateDirectValue={() => {}}
				/>
			</Grid>
			<Grid item xs={3}>
				<InputConfig
					label="Banner Height"
					keyData={bannerObj?.height}
					editable={false}
					isObjectEditor={false}
					directValue={bannerObj?.height}
					updateDirectValue={() => {}}
				/>
			</Grid>
		</Grid>
	);
};

export default PlatformBannerConfig;
